// Configuration file for API and auth settings

// 🔵 РАЗРАБОТКА: установите false для использования мок-данных
// 🟢 ПРОДАКШН: установите true для использования реального API
// Включите использование реального API в development при наличии локального сервера
export const USE_REAL_API = true;

// Базовый URL API. Приоритет источников:
// 1) Vite клиентские переменные: import.meta.env.VITE_API_BASE_URL
// 2) Node серверные переменные: process.env.API_BASE_URL
// 3) Фоллбек: локальный адрес
const viteBase = (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.VITE_API_BASE_URL) ? (import.meta as any).env.VITE_API_BASE_URL : undefined;
const nodeBase = (typeof process !== 'undefined' && process.env && process.env.API_BASE_URL) ? process.env.API_BASE_URL : undefined;
export const API_URL = viteBase || nodeBase || 'http://localhost:8000/api';

// Ключи для хранения токенов и данных пользователя
export const ACCESS_TOKEN_KEY = 'safonova_access_token';
export const REFRESH_TOKEN_KEY = 'safonova_refresh_token';
export const USER_KEY = 'safonova_user';

// Public site base URL used for canonical / open-graph tags.
// Priority sources:
// 1) Vite client: import.meta.env.VITE_BASE_URL
// 2) Node server: process.env.BASE_URL
// 3) Fallback to empty string (relative URLs will be used)
const viteBaseUrl = (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.VITE_BASE_URL) ? (import.meta as any).env.VITE_BASE_URL : undefined;
const nodeBaseUrl = (typeof process !== 'undefined' && process.env && process.env.BASE_URL) ? process.env.BASE_URL : undefined;
export const BASE_URL = viteBaseUrl || nodeBaseUrl || '';